(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bridal-morning-content"] && !Shopify.designMode) return;
  try {
    function initialiseBridalOrder() {
    const form = document.getElementById('GGBridalOrder');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const quantity = form.querySelector('[name="quantity"]');
    const total = form.querySelector('#GGBridalTotal');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: total.dataset.currency || 'AUD'
    });
    const button = form.querySelector('button[type="submit"]');
    const bookingCalendar = form.querySelector('gg-delivery-calendar');
    const unitPrice = document.getElementById('GGBridalUnitPrice');
    let price = 0;
    function updateTotal() {
      const count = Number(quantity.value);
      if (price > 0 && Number.isInteger(count) && count >= 6) {
        total.textContent = `${total.dataset.totalLabel} ${money.format(count * price / 100)}`;
      } else {
        total.textContent = '';
      }
    }
    const juiceInputs = Array.from(form.querySelectorAll('[data-juice-choice]'));
    const juiceCount = form.querySelector('#GGBridalJuiceCount');
    function updateJuiceChoices() {
      const counts = juiceInputs.map(input => Number(input.value));
      const count = counts.reduce((sum, value) => sum + (Number.isFinite(value) ? value : 0), 0);
      const boxes = Number(quantity.value);
      const valid = counts.every((value, index) => juiceInputs[index].value !== '' && Number.isInteger(value) && value >= 0)
        && Number.isInteger(boxes) && boxes >= 6 && count === boxes;
      juiceCount.textContent = juiceCount.dataset.countTemplate.replace('[selected]', count).replace('[boxes]', Number.isFinite(boxes) ? boxes : 0);
      juiceInputs[0].setCustomValidity(valid ? '' : juiceCount.dataset.error);
      return valid;
    }
    juiceInputs.forEach(input => input.addEventListener('input', updateJuiceChoices));
    quantity.addEventListener('input', updateJuiceChoices);
    window.addEventListener('pageshow', updateJuiceChoices);
    form.addEventListener('reset', () => window.setTimeout(updateJuiceChoices, 0));
    updateJuiceChoices();
    quantity.addEventListener('input', updateTotal);
    fetch(form.dataset.productUrl, {headers: {'Accept': 'application/json'}})
      .then((response) => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      })
      .then((product) => {
        const variant = product.variants.find((item) => String(item.id) === form.elements.id.value);
        if (!variant || !variant.available || variant.price <= 0) return;
        price = variant.price;
        unitPrice.textContent = unitPrice.dataset.priceTemplate.replace('[price]', money.format(price / 100));
        updateTotal();
        button.disabled = false;
      })
      .catch(() => { button.disabled = true; });
    form.addEventListener('submit', (event) => {
      if (!bookingCalendar?.validate()) { event.preventDefault(); return; }
      form.querySelector('[data-bridal-date]').value = bookingCalendar.booking.date;
      form.querySelector('[data-bridal-window]').value = bookingCalendar.booking.window;
      updateJuiceChoices();
      form.querySelectorAll('textarea[required], input[type="tel"][required]').forEach((input) => {
        input.value = input.value.trim();
      });
      if (button.disabled || !form.reportValidity()) event.preventDefault();
    });
  }
  initialiseBridalOrder();
  document.addEventListener('shopify:section:load', initialiseBridalOrder);
  } catch(e) { console.error(e); }
})();

})();
